import React, { useState } from "react";
import Button from "../common/Button";
import ConfirmationModalNew from "../common/ConfirmationModalNew";
import PrivacyPolicyContent from "../my-profile/legal/PrivacyPolicyContent";
import TermsOfUseContent from "../my-profile/legal/TermsOfUseContent";
import DisclaimerContent from "../my-profile/legal/DisclaimerContent";

const Footer = ({
  effectiveDate = "",
  privacyEffectiveDate,
  termsEffectiveDate,
  disclaimerEffectiveDate,
}) => {
  const [activeLegalModal, setActiveLegalModal] = useState(null); // 'privacy' | 'terms' | 'disclaimer' | null

  const resolvedPrivacyDate = privacyEffectiveDate || effectiveDate;
  const resolvedTermsDate = termsEffectiveDate || effectiveDate;
  const resolvedDisclaimerDate = disclaimerEffectiveDate || effectiveDate;

  // Same content wrapper + props as CompliancePopup for consistent popup styling
  const renderPrivacyPolicyContent = () => (
    <div className="px-2">
      <PrivacyPolicyContent
        effectiveDate={resolvedPrivacyDate}
        handleAgree={() => setActiveLegalModal(null)}
        handleDecline={() => setActiveLegalModal(null)}
        showFooter={false}
        isPopupVersion={true}
      />
    </div>
  );

  const renderTermsOfUseContent = () => (
    <div className="px-2">
      <TermsOfUseContent
        effectiveDate={resolvedTermsDate}
        handleAgree={() => setActiveLegalModal(null)}
        handleDecline={() => setActiveLegalModal(null)}
        showFooter={false}
        isPopupVersion={true}
      />
    </div>
  );

  const renderDisclaimerContent = () => (
    <div className="px-2">
      <DisclaimerContent
        effectiveDate={resolvedDisclaimerDate}
        disableInnerScroll={true}
        isPopupVersion={true}
      />
    </div>
  );

  return (
    
    <div className="relative flex flex-col md:flex-row items-center justify-center md:justify-start gap-4 md:gap-[100px] py-3 px-8 min-h-[5vh] footer">
      <div className="flex items-center gap-2">
      <img 
        src="/logo/footer/reel-outline.svg" 
        alt="Reel" 
        className="w-auto h-6" 
      />
      </div>
      <div className="flex items-center space-x-2 md:space-x-3 text-[14px] font-normal font-medium leading-[24px] text-gray-600">
        <Button
          onClick={() => setActiveLegalModal("privacy")}
          text="Privacy Policy"
          type="legal"
          className="!text-[14px] !font-medium !leading-[24px] text-gray-600"
        />
        <span>|</span>
        <Button
          onClick={() => setActiveLegalModal("terms")}
          text="Terms of Use"
          type="legal"
          className="!text-[14px] !font-medium !leading-[24px] text-gray-600"
        />
        <span>|</span>
        <Button
          onClick={() => setActiveLegalModal("disclaimer")}
          text="Disclaimer"
          type="legal"
          className="!text-[14px] !font-medium !leading-[24px] text-gray-600"
        />

        {activeLegalModal && (
          <ConfirmationModalNew
            open={true}
            title={
              activeLegalModal === "privacy"
                ? "Privacy Policy"
                : activeLegalModal === "terms"
                ? "Terms Of Use"
                : "Disclaimer"
            }
            content={
              activeLegalModal === "privacy"
                ? renderPrivacyPolicyContent
                : activeLegalModal === "terms"
                ? renderTermsOfUseContent
                : renderDisclaimerContent
            }
            handleClose={() => setActiveLegalModal(null)}
            onCross={() => setActiveLegalModal(null)}
            hideCloseIcon={false}
            hideActions={true}
            setWideModal={true}
            hideHR={true}
            maskClosable={false}
            className="!gap-0 !pt-0 !max-w-[950px] !w-[950px] !min-w-[950px] !max-h-[85vh]"
            headClassName="!bg-teal-25 rounded-t-[4px] relative [&>div:last-child]:!top-1/2 [&>div:last-child]:!-translate-y-1/2"
          />
        )}
      </div>
    </div>
  );
};

export default Footer;